import {Map as ImmutableMap} from 'immutable';
import {CHANGE_PARAMS} from '../actions/actions';
import {FETCH_SIMULATION_FAILURE, FETCH_SIMULATION_SUCCESS, REQUEST_SIMULATION} from '../actions/async-actions';


const initialState = ImmutableMap({
        paymentAmount: '100',
        cardType: 'MASTERCARD',
        paymentCurrency: 'CHF',
        paymentCurrencyResult: 'CHF',
        simulation: {
            operationDate: '',
            paymentAmount: '',
            convertedAmount: '',
            exchangeRate: '',
            bankCharges: '',
            ratio: ''
        },
        isFetching: true,
        error: false,
        changed: false
});

export const appState = (state = initialState, action) => {
    let updatedState = state;

    switch (action.type) {
        case CHANGE_PARAMS:
            updatedState = updatedState.set(action.field, action.value);
            return updatedState.set('changed', true);
        case REQUEST_SIMULATION:
            updatedState = updatedState.set('changed', false);
            return updatedState.set('isFetching', true);
        case FETCH_SIMULATION_SUCCESS:
            updatedState =  updatedState.set('error', false);
            updatedState = updatedState.set('isFetching', false);
            updatedState = updatedState.set('paymentCurrencyResult', updatedState.get('paymentCurrency'));
            return updatedState.set('simulation', action.simulation);
        case FETCH_SIMULATION_FAILURE:
            updatedState = updatedState.set('changed', true);
            updatedState = updatedState.set('error', true);
            return updatedState.set('isFetching', false);
        default:
            return updatedState;
    }
};
